<template>
  <div id="back_top" class="back_top" @click="toTop()" v-show="showBack"></div>
</template>

<script>
export default {
  data () {
    return {
      showBack: false
    }
  },
  methods: {
    scrollView: function () {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if (scrollTop >= 100) {
        this.showBack = true
      } else {
        this.showBack = false
      }
    },
    toTop () {
      window.pageYOffset = 0
      document.documentElement.scrollTop = 0
      document.body.scrollTop = 0
    }
  },
  mounted () {
    window.addEventListener('scroll', this.scrollView, true)
  }
}
</script>

<style scoped="scoped">
.back_top {
  position: fixed;
  bottom: 130px;
  right: 15px;
  width: 35px;
  height: 35px;
  background-image: url(../assets/icon-top.png);
  background-size: cover;
  background-position: center center;
  z-index: 2000;
}
</style>



// WEBPACK FOOTER //
// src/view/back-top.vue